import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '/src/components/Home/Home.vue'

Vue.use(VueRouter);
const routes = [
    {
        path: '/',
        component: Home,
        meta: { title: '仓选科技' }
    }
];
const router = new VueRouter({
    mode: 'history',
    routes
})
router.beforeEach((to, from, next) => {
    window.document.title = to.meta.title || '仓选科技';
    next();
})
export default router